import styled from "styled-components";
import { StyledLink } from "globalStyles/Containers";
import IconDispatcher from "components/Icons/IconDispatcher";
import { Main } from "globalStyles/Containers";

export const HistoryLink = styled(StyledLink)`
  margin-left: auto;
  text-transform: uppercase;
`;

export const CurrentNotificationTitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
`;

export const CurrentNotificationTitleCaseNumber = styled.span`
  text-transform: ${({ upperCase }) => (upperCase ? "uppercase" : "none")};
`;

export const CurrentNotificationProvider = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
`;

export const CurrentNotificationWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.backgroundAlertBorderColor};
  border-bottom: 1px solid ${({ theme }) => theme.specialBannerBorderTop};
`;

export const CurrentNotificationContainer = styled.div`
  width: 360px;
  display: flex;
  padding: 19px 0 19px 29px;
`;

export const CurrentNotificationIcon = styled(IconDispatcher)`
  width: 40px;
  height: 40px;
`;

export const Links = styled.div`
  display: flex;
`;

export const MainContainer = styled(Main)`
  flex-grow: 1;
`;

export { Button } from "../../globalStyles/Containers";
